/* Judge.me product review snapshot from supplied storefront, captured 2026-10-17.
 * Full text/ratings preserved; bundled for file:// previews. */
(() => {
  "use strict";
  const snapshot = {
  "source": "https://headsuphockey.ai/products/heads-up-hockey#judgeme_product_reviews",
  "captured": "2026-10-17",
  "updated": "2026-10-13T22:09:52Z",
  "average": "4.69",
  "total": 59,
  "distribution": [
    {
      "stars": 5,
      "count": 46
    },
    {
      "stars": 4,
      "count": 9
    },
    {
      "stars": 3,
      "count": 3
    },
    {
      "stars": 2,
      "count": 1
    },
    {
      "stars": 1,
      "count": 0
    }
  ],
  "reviews": [
    {
      "id": "23d219b7-e4a5-46b7-a29c-5b9f8763981c",
      "author": "Matthew Allatin",
      "rating": 5,
      "date": "2024-11-03",
      "verified": true,
      "title": "",
      "body": "Great product both my kids really enjoy it and i can see immediate improvements in their game"
    },
    {
      "id": "f4d244b3-906b-45f6-9be7-2a2c8bfba90d",
      "author": "Jared P",
      "rating": 5,
      "date": "2024-10-22",
      "verified": true,
      "title": "Fantastic Training Tool for Young Hockey Players!",
      "body": "I purchased the Heads Up Hockey training system for my son, who plays squirt-level hockey, and I couldn’t be more impressed! After just a few hours of practice, he mentioned how much better he felt at stick handling with his head up on the ice. The training system really emphasizes keeping your eyes off the puck and focusing on the game, which is an essential skill for any young player.\nWhat my son loves most is the interactive leaderboard, where he can track his progress and compete with his previous scores. It adds a fun, competitive element to his training sessions and keeps him motivated to improve. If you’re looking for a tool to help develop on-ice awareness and puck handling, this is an excellent choice!"
    },
    {
      "id": "9df31c0d-7a4d-434c-b8aa-4d077465865d",
      "author": "Erik Figi",
      "rating": 5,
      "date": "2024-10-17",
      "verified": true,
      "title": "Kid's love it",
      "body": "This is the first hockey training, or any sport for that matter, that my kids want to play the second they get home from school. They are now competing with each other."
    },
    {
      "id": "e1b83cba-865a-461f-983c-10f23fcdb7b5",
      "author": "Jason Wood",
      "rating": 5,
      "date": "2024-07-02",
      "verified": true,
      "title": "Stands above...",
      "body": "The Heads up Hockey app has been an incredible add to our dry ice training program. Being a new parent to a new to hockey kid, I came across a add for the Heads up app and figured my son loves interactive games and needs to learn some fundamenals so why not. I came within a week and gets daily use at our house now. It's easy to use and makes learning hockey fun and teaches good habits.  Michael and his team also where very helpful with follow up questions I add. I hope they continue to evolve the app and grow it more. It has endless potentional and can be used anywhere"
    },
    {
      "id": "5608cd42-3abe-489b-ad5f-ea6b116d5f50",
      "author": "Customer",
      "rating": 5,
      "date": "2024-06-03",
      "verified": false,
      "title": "#1 Off-Ice Hockey Stickhandling Training Aid for Vision Development!!",
      "body": "The name of the product says it all.  If you're looking for a product that develops vision training for hockey players, young or old, just starting out, or well on their journey, HeadsUpHockey.ai is a must have.  Most players don't work on vision training because it's difficult.  But not now!!  After weeks of testing the app with players I train here at my facility here in Minnesota, I never had to tell any of the players to get their eyes up, they were glued to the screen.  I'm recommending Heads Up Hockey to everyone, and I am to you tooooo :)"
    }
  ]
};
  const container = document.getElementById("reviews-content");
  if (!container) return;
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  const summary = element("div", "reviews-summary");
  summary.appendChild(element("strong", "reviews-average", `${snapshot.average} / 5`));
  summary.appendChild(element("span", "reviews-total", `Based on ${snapshot.total} Judge.me reviews`));
  container.appendChild(summary);
  const distribution = element("div", "reviews-distribution");
  distribution.setAttribute("aria-label", `Rating breakdown for all ${snapshot.total} reviews`);
  snapshot.distribution.forEach(({stars, count}) => {
    const row = element("div", "reviews-distribution-row");
    row.appendChild(element("span", "", `${stars} stars`));
    const bar = element("meter", "reviews-distribution-meter");
    bar.min = 0;
    bar.max = snapshot.total;
    bar.value = count;
    bar.setAttribute("aria-label", `${count} of ${snapshot.total} reviews rated ${stars} stars`);
    row.appendChild(bar);
    row.appendChild(element("span", "", String(count)));
    distribution.appendChild(row);
  });
  container.appendChild(distribution);
  container.appendChild(element("p", "reviews-snapshot-note", `Showing ${snapshot.reviews.length} reviews from the saved storefront, October 17, 2026. This preview does not update live.`));
  const list = element("div", "reviews-list");
  snapshot.reviews.forEach((review) => {
    const article = element("article", "cl-review-card");
    const header = element("div", "review-header");
    header.appendChild(element("strong", "review-author", review.author));
    const date = element("time", "review-date", new Intl.DateTimeFormat("en-US", {year: "numeric", month: "short", day: "numeric", timeZone: "UTC"}).format(new Date(`${review.date}T12:00:00Z`)));
    date.dateTime = review.date;
    header.appendChild(date);
    article.appendChild(header);
    const rating = element("span", "review-stars", "★".repeat(review.rating));
    rating.setAttribute("role", "img");
    rating.setAttribute("aria-label", `${review.rating} out of 5 stars`);
    article.appendChild(rating);
    if (review.verified) article.appendChild(element("span", "review-verified", "Verified buyer"));
    if (review.title) article.appendChild(element("h3", "review-title", review.title));
    article.appendChild(element("p", "review-body", review.body));
    list.appendChild(article);
  });
  container.appendChild(list);
})();
